import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Button, Divider, Flex, FocusLock, Heading, Slide, Text, useOutsideClick } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useEffect, useRef, useState } from 'react';
import { FilterPanelClearButton, FilterPanelCloseButton } from '../../utils/FilterPanelControls';
import { createCheckboxList } from '../../utils/createCheckboxList';
import { onPanelEscapeKeyDown } from '../../utils/filterPanelKeyboard';
import { useFilterPanelTypography } from '../../utils/useFilterPanelTypography';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var FILTERS_HEADING_ID = 'SRP-Filters-heading';
var CLEAR_FILTERS_ENABLER = 2;
export default function Filters(_ref) {
  var _code$freeParking, _label$reset, _info$lift, _info$lift2;
  var defaultFilters = _ref.defaultFilters,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onChangeFilters = _ref.onChangeFilters,
    labels = _ref.labels,
    leftIcon = _ref.leftIcon,
    buttonProps = _ref.buttonProps;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFilterPanelTypogr = useFilterPanelTypography(buttonProps),
    headingTypography = _useFilterPanelTypogr.headingTypography,
    labelTypography = _useFilterPanelTypogr.labelTypography,
    mergedButtonProps = _useFilterPanelTypogr.mergedButtonProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFilterOpen = _useState2[0],
    setIsFilterOpen = _useState2[1];
  var _useState3 = useState(defaultFilters),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFilters = _useState4[0],
    setSelectedFilters = _useState4[1];
  var ref = useRef(null);
  var filterButtonRef = useRef(null);
  useOutsideClick({
    ref: ref,
    handler: () => setIsFilterOpen(false)
  });
  var filterByButton = labels.filterByButton,
    filters = labels.filters;
  var label = filters.label,
    code = filters.code,
    info = filters.info;
  var PARKING_FILTERS = [{
    name: label === null || label === void 0 ? void 0 : label.freeParking,
    code: code === null || code === void 0 || (_code$freeParking = code.freeParking) === null || _code$freeParking === void 0 ? void 0 : _code$freeParking[0]
  }, {
    name: label === null || label === void 0 ? void 0 : label.chargeableOnsiteParking,
    code: code === null || code === void 0 ? void 0 : code.chargeableOnsiteParking
  }, {
    name: label === null || label === void 0 ? void 0 : label.chargeableOffsiteParking,
    code: code === null || code === void 0 ? void 0 : code.chargeableOffsiteParking
  }];
  var FACILITIES_FILTERS = [{
    name: label === null || label === void 0 ? void 0 : label.airCon,
    code: code === null || code === void 0 ? void 0 : code.airCon
  }, {
    name: label === null || label === void 0 ? void 0 : label.lift,
    code: code === null || code === void 0 ? void 0 : code.lift
  }, {
    name: label === null || label === void 0 ? void 0 : label.meet,
    code: code === null || code === void 0 ? void 0 : code.meet
  }, {
    name: label === null || label === void 0 ? void 0 : label.restaurant,
    code: code === null || code === void 0 ? void 0 : code.restaurant
  }];
  useEffect(() => {
    document.body.style.overflow = isFilterOpen ? 'hidden' : 'auto';
  }, [isFilterOpen]);
  return _jsxs(_Fragment, {
    children: [_jsx(Slide, {
      direction: 'left',
      in: isFilterOpen,
      unmountOnExit: true,
      style: {
        zIndex: 999,
        background: 'rgba(0,0,0,0.5)'
      },
      children: _jsx(FocusLock, {
        restoreFocus: true,
        finalFocusRef: filterButtonRef,
        children: _jsxs(Box, _objectSpread(_objectSpread({}, panelStyles), {}, {
          "data-testid": "SRP-Filters-content",
          ref: ref,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": FILTERS_HEADING_ID,
          tabIndex: -1,
          onKeyDown: onPanelEscapeKeyDown(() => setIsFilterOpen(false)),
          children: [_jsxs(Flex, {
            justifyContent: "space-between",
            alignItems: "center",
            mt: "2.5rem",
            children: [_jsx(Heading, _objectSpread(_objectSpread({
              as: "h2",
              id: FILTERS_HEADING_ID,
              size: "none"
            }, headingTypography), {}, {
              color: "var(--chakra-colors-darkGrey1)",
              children: label === null || label === void 0 ? void 0 : label.header
            })), _jsx(FilterPanelCloseButton, {
              testId: "SRP-Filters-Close-button",
              label: t('searchResults.filters.close', {
                defaultValue: 'Close'
              }),
              onClose: () => setIsFilterOpen(false)
            })]
          }), selectedFilters.length >= CLEAR_FILTERS_ENABLER && _jsx(FilterPanelClearButton, _objectSpread(_objectSpread({}, clearFiltersStyles), {}, {
            testId: "SRP-Clear-filters",
            label: (_label$reset = label === null || label === void 0 ? void 0 : label.reset) !== null && _label$reset !== void 0 ? _label$reset : t('tableFilter.clearAll', {
              defaultValue: 'Clear all filters'
            }),
            onClear: handleClearFilters
          })), _jsx(Divider, _objectSpread({}, dividerStyles)), _jsxs(Box, {
            role: "group",
            "aria-labelledby": "SRP-Filters-parking-heading",
            children: [_jsx(Heading, _objectSpread(_objectSpread({
              as: "h3",
              id: "SRP-Filters-parking-heading",
              mb: "sm",
              size: "none"
            }, headingTypography), {}, {
              color: "var(--chakra-colors-darkGrey1)",
              children: label === null || label === void 0 ? void 0 : label.parking
            })), createCheckboxList('SRP', selectedFilters, handleFilterChange, PARKING_FILTERS, (_info$lift = info === null || info === void 0 ? void 0 : info.lift) !== null && _info$lift !== void 0 ? _info$lift : '', false, labelTypography)]
          }), _jsx(Divider, _objectSpread({}, dividerStyles)), _jsxs(Box, {
            role: "group",
            "aria-labelledby": "SRP-Filters-facilities-heading",
            children: [_jsx(Heading, _objectSpread(_objectSpread({
              as: "h3",
              id: "SRP-Filters-facilities-heading",
              mb: "sm",
              size: "none"
            }, headingTypography), {}, {
              color: "var(--chakra-colors-darkGrey1)",
              children: label === null || label === void 0 ? void 0 : label.facilities
            })), createCheckboxList('SRP', selectedFilters, handleFilterChange, FACILITIES_FILTERS, (_info$lift2 = info === null || info === void 0 ? void 0 : info.lift) !== null && _info$lift2 !== void 0 ? _info$lift2 : '', false, labelTypography)]
          })]
        }))
      })
    }), _jsx(Button, _objectSpread(_objectSpread(_objectSpread({
      ref: filterButtonRef,
      "data-testid": "SRP-controls-filter-by-button",
      size: "sm",
      variant: "genericSecondary",
      mr: {
        base: 'md',
        lg: 'lg'
      },
      isDisabled: isDisabled,
      onClick: () => setIsFilterOpen(true),
      "aria-haspopup": "dialog",
      "aria-expanded": isFilterOpen,
      "aria-controls": isFilterOpen ? 'SRP-Filters-content' : undefined
    }, filterButtonWidth), {}, {
      leftIcon: leftIcon
    }, mergedButtonProps), {}, {
      children: _jsx(Text, _objectSpread(_objectSpread({
        as: "span"
      }, labelTypography), {}, {
        children: filterByButton
      }))
    }))]
  });
  function handleFilterChange(e) {
    var newState = e.target.checked ? [...selectedFilters, e.target.value] : selectedFilters.filter(elem => elem !== e.target.value);
    setSelectedFilters(newState);
    onChangeFilters(newState);
  }
  function handleClearFilters() {
    setSelectedFilters([]);
    onChangeFilters([]);
  }
}
var filterButtonWidth = {
  w: {
    mobile: '8.75rem',
    xs: '10.25rem',
    sm: '7.75rem',
    lg: '11.5rem'
  }
};
var panelStyles = {
  background: 'baseWhite',
  height: '100dvh',
  width: 'full',
  px: 'lg',
  maxWidth: {
    base: '19rem',
    sm: '21.875rem',
    md: '23.25rem',
    lg: '26.25rem',
    xl: '30.375rem'
  },
  overflow: 'hidden',
  zIndex: '9999'
};
var dividerStyles = {
  borderColor: 'lightGrey2',
  my: 'lg'
};
var clearFiltersStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '3',
  textDecoration: 'underline',
  color: 'btnSecondaryEnabled',
  marginTop: 'md',
  marginBottom: 'lg',
  _hover: {
    cursor: 'pointer'
  }
};